<style lang="less" scoped>
.rate-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-row .rate-input {
  width: 120px;
  margin-left: 8px;
}

.rate-unit {
  margin-left: 8px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.logBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">积分参数配置</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" class="detail-form">
          <div class="detail-form-parent-div">
            <div class="margin-bt-10">
              <div class="flex rate-row">
                <el-form-item class="detail-from-input" label="积分比例" prop="rate" label-width="80px">
                  <span>1元 =</span>
                  <el-input v-model="detailForm.rate" class="rate-input" clearable
                    oninput="value=value.replace(/^0|[^0-9]/g, '')" size="small" placeholder="请输入整数"
                    maxlength="20"></el-input>
                  <span class="rate-unit">积分</span>
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="积分领取有效期" prop="receiveValidatyDay" label-width="120px">
                  <el-input v-model="detailForm.receiveValidatyDay" style="width:130px;" clearable
                    oninput="value=value.replace(/^0|[^0-9]/g, '')" size="small" placeholder="请输入整数"
                    maxlength="20"></el-input>天
                </el-form-item>
              </div>
              <div class="flex">
                <el-form-item class="detail-from-input" label="积分使用有效期" prop="useValidatyDay" label-width="120px">
                  <el-input v-model="detailForm.useValidatyDay" style="width:130px;" clearable
                    oninput="value=value.replace(/^0|[^0-9]/g, '')" size="small" placeholder="请输入整数"
                    maxlength="100"></el-input>天
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <el-divider></el-divider>
        <h1>更新记录</h1>
        <el-table :data="tableData" border style="width: 100%">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="lastModifiedByName" label="更新人" width="180" align="center">
          </el-table-column>
          <el-table-column prop="lastModifiedWhen" label="更新时间" width="180" align="center">
          </el-table-column>
          <el-table-column prop="rate" label="积分比例" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.rate.indexOf(',') > -1">
                <span>{{ scope.row.rate.slice(0, scope.row.rate.indexOf(',')) }}</span> >
                <span>{{ scope.row.rate.slice(scope.row.rate.indexOf(',') + 1) }}</span>
              </p>

              <p v-if="scope.row.rate.indexOf(',') < 0">{{ scope.row.rate }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="receiveValidatyDay" label="积分领取有效期" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.receiveValidatyDay.indexOf(',') > -1">
                <span>{{ scope.row.receiveValidatyDay.slice(0, scope.row.receiveValidatyDay.indexOf(',')) }}</span> >
                <span>{{ scope.row.receiveValidatyDay.slice(scope.row.receiveValidatyDay.indexOf(',') + 1) }}</span>
              </p>

              <p v-if="scope.row.receiveValidatyDay.indexOf(',') < 0">{{ scope.row.receiveValidatyDay }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="useValidatyDay" label="积分使用有效期" width="180" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.useValidatyDay.indexOf(',') > -1">
                <span>{{ scope.row.useValidatyDay.slice(0, scope.row.useValidatyDay.indexOf(',')) }}</span> >
                <span>{{ scope.row.useValidatyDay.slice(scope.row.useValidatyDay.indexOf(',') + 1) }}</span>
              </p>

              <p v-if="scope.row.useValidatyDay.indexOf(',') < 0">{{ scope.row.useValidatyDay }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="list-pagination">
          <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
        </div>
      </div>

      <div class=" flex-r-end">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      detailForm: {

      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //获取数据
    init() {
      this.detailForm.corpNo = this.$store.state.corpNo
      this.getList()
      this.getListData(this.pagination, true);
    },

    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.couponNo = _.$route.query.couponNo;
      _.$H.post(_, _.$A.coupon.integralConfigPage, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    getList() {
      let _ = this
      _.$H.post(_, _.$A.coupon.integralConfigList, {}).then((res) => {
        if (res.data.data) {
          _.detailForm = res.data.data[0]
          _.editFlag = true
        } else {
          _.editFlag = false
        }
      });

    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_.editFlag) {

            _.$H.post(_, _.$A.coupon.integralConfigAdd, _.detailForm).then(res => {
              if (res.status === 200) {
                _.getListData(this.pagination, true);
              }
            })
            _.detailForm = {}
          } else {

            _.$H.post(_, _.$A.coupon.integralConfigAdd, _.detailForm).then(res => {
              if (res.status === 200) {
                _.getListData(this.pagination, true);
              }
            })
            _.detailForm = {}
          }
        }
      })
    },
    // 取消
    resetForm() {
      this.detailForm = {};
      this.$router.push({
        name: pageConfig.listRouter,
      });
    },
  },
};
</script>
